<template>
    <div class="meeting-details max-content">
        <div class="banner-show">
            <div class="cover">
                <van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
                    <van-swipe-item v-for="(item, key, index) in swiperImg" :key="index" @click="clickSwiperImg(item)">
                        <img :src="item.image" alt="">
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="countDown" v-if="showTimeCountDown">
            <h4>距离会议开始 </h4>
            <van-count-down :time="time">
                <template #default="timeData">
                    <span class="block">{{ timeData.days }}</span>
                    <span class="colon">天</span>
                    <span class="block">{{ timeData.hours }}</span>
                    <span class="colon">时</span>
                    <span class="block">{{ timeData.minutes }}</span>
                    <span class="colon">分</span>
                    <span class="block">{{ timeData.seconds }}</span>
                    <span class="colon">秒</span>

                </template>
            </van-count-down>
        </div>
        <div class="relation824">
            <van-row>
                <van-col span="12">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[0])">
                        <img src="./images/1.png" alt="">
                    </a>
                </van-col>
                <van-col span="6">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[1])">
                        <img src="./images/2.png" alt="">
                    </a>
                </van-col>
                <van-col span="6">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[2])">
                        <img src="./images/3.png" alt="">
                    </a>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="6">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[3])">
                        <img src="./images/4.png" alt="">
                    </a>

                </van-col>
                <!-- <van-col span="6">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[4])">
                        <img src="./images/5.png" alt="">
                    </a>
                </van-col> -->
               
                <van-col span="6">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[4])">
                        <img src="./images/7.png" alt="">
                    </a>
                </van-col>
                <van-col span="12">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[5])">
                        <img src="./images/12.png" alt="">
                    </a>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="12">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[6])">
                        <img src="./images/10.png" alt="">
                    </a>
                </van-col>
                <van-col span="6">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[7])">
                        <img src="./images/8.png" alt="">
                    </a>
                </van-col>
                <van-col span="6">
                    <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[8])">
                        <img src="./images/11.png" alt="">
                    </a>
                </van-col>
               
            </van-row>
            <img class="bottom-img" src="./images/bottom.png" alt="">

        </div>
      
        <bottom :name="meeting_name" :meeting_id="meeting_id" :show_support="show_support" v-if="bottom_word_show">
        </bottom>
    </div>
</template>
<script>
// import Register from "../../components/Users/Register.vue"
import { MeetingButtons, MeetingsCarousel, MeetingsDetails, companyImages } from '../../../config/interface.js'
import { CountDown } from 'vant'
import Bottom from '../Meeting/Bottom.vue'
export default {
    components: {
        CountDown,
        Bottom
    },
    data() {
        return {
            meetingButton: {},    //会议按钮
            swiperImg: [],
            meeting_id: '824',
            time: '',
            showTimeCountDown: false,
            show_support: 1,
            bottom_word_show: 0,
            type:1,
        }
    },
    beforeRouteEnter(to, from, next) {
        //  修复iOS版微信HTML5 History兼容性问题
        if (to.path !== location.pathname) {

            location.assign(to.fullPath)
        } else {
            next()
        }
    },
    mounted() {
        this.getMeetingButtons(this.meeting_id);
        this.getMeetingCarousel();
        this.getMeetingDetails();
        this.realmName=window.location.host;
        if(this.realName.indexOf('xgzx.talkmed.com')>-1){
            this.type=1;
        }
        if(this.realName.indexOf('vascularnews.cn')>-1){
            this.type=2;
        }
    },
    methods: {
        getImages() {
            const url = companyImages;
            let params = {
                meeting_id: this.meeting_id,
            }
            const method = "POST";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.images = res.data;
                    }
                })
        },
        //会议轮播
        getMeetingCarousel() {
            const url = MeetingsCarousel;
            let params = {
                meeting_id: this.meeting_id
            }
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.swiperImg = data;
                    }
                })
        },
        clickSwiperImg(item) {
            window.location.href = item.link;
        },
        //会议按钮
        getMeetingButtons(id) {
            const url = MeetingButtons;
            const method = 'POST';
            let params = {
                meeting_id: id
            };
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.meetingButton = data
                        // console.log(this.meetingButton)
                    }
                })
        },
        //会议详情
        getMeetingDetails() {
            const url = MeetingsDetails;
            const method = 'POST';
            let params = {
                meeting_id: this.meeting_id
            }
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        document.title = data.name;
                        this.meeting_name = data.name;
                        this.bottom_word_show = data.bottom_word_show;
                        this.show_support = data.platform_support_show;
                        // this.meeting_dates=data.meeting_dates;
                        this.time = this.countdownTo(data.start_at)
                        if (this.time <= 100) {
                            this.showTimeCountDown = false
                        } else {
                            this.showTimeCountDown = true

                        }

                        console.log(this.time)
                        //微信浏览器  请求jsdk
                        if (common.is_weixin()) {
                            common.wxShare(data.name, data.title, data.shareimg);
                        }
                    }
                })
        },
        countdownTo(targetDateString) {
            // 将目标日期字符串转换为Date对象
            const targetDate = new Date(targetDateString);
            // 获取当前时间的Date对象
            const currentDate = new Date();
            // 计算时间差（以毫秒为单位）
            const differenceMs = targetDate.getTime() - currentDate.getTime();
            // 返回剩余时间（如果为负数，则表示目标日期已过）
            return differenceMs;
        },
        // 将 skipLink 方法移至此处
        skipLink(item) {
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }

    }
}
</script>
<style lang="scss" scoped>
.meeting-details {
    background: #FFEDEE;
    display: flex;
    flex-direction: column;

    .banner-show {
        width: 100%;
        padding: 0px;

        .cover {
            width: 100%;

            img {
                width: 100%;
            }
        }
    }

    .relation824 {
        // overflow: auto;
        padding: 0.3rem 0.3rem;
        @include flex(row);
        align-items: center;
        flex-wrap: wrap;
        width: 100%;

        .van-row {
            width: 100%;
            line-height: 0;

        }

        .van-col {
            line-height: 0;
        }


        a {
            display: inline-block;
            text-align: center;
            line-height: 0;
            padding: 0.15rem;
            width: 100%;
            box-sizing: border-box;
            // margin-bottom: 16px;
        }

        img {
            width: 100%;
            height: 100%;

        }

        .bottom-img {
            width: 98% !important;
            margin: 25px auto 0;
        }
    }

}

.countDown {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    width: fit-content;
    margin: 20px auto 10px;
    background: linear-gradient(275deg, #c42128 0%, #900a10 99%);
    border-radius: 8px;


    h4 {
        color: #fff;
        font-size: 12px;
        text-align: center;
        margin-right: 10px;
        font-weight: 500;
    }
}

.colon {
    display: inline-block;
    // margin: 0 4px;
    color: #ffffff;
    line-height: 30px;
    font-size: 12px;
    font-weight: 500;
    padding: 0 2px;



}



.block {
    display: inline-block;
    font-size: 12px;
    text-align: center;
    border-radius: 5px;
    line-height: 20px;
    font-weight: 500;
    width: 28px;
    height: 20px;
    cursor: pointer;
    color: #940B13;
    background: linear-gradient(180deg, #FFFFFF 29%, #DFE3E8 100%);
    box-shadow: 0px 2px 4px 0px rgba(57, 39, 27, 0.1505);

}
.bottom-number{
    margin: 10px;
    color: #b5b5b5;
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    height: 60px;
}

</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting824/index.vue